import { render, staticRenderFns } from "./RequiredFilesList.vue?vue&type=template&id=492be603&scoped=true"
import script from "./RequiredFilesList.vue?vue&type=script&lang=js"
export * from "./RequiredFilesList.vue?vue&type=script&lang=js"
import style0 from "./RequiredFilesList.vue?vue&type=style&index=0&id=492be603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492be603",
  null
  
)

export default component.exports